import { Box, Tooltip, Typography } from '@mui/material';
import { RxCross2 } from 'react-icons/rx';
import { Tag } from '@/apis/agency/taggings/types';
import { getTagColors, titleizeTagName } from './businessTags';
import { formatDate } from '@/utils/helperFunctions';

interface Props {
  tag: Tag;
  onRemove?: (tag: Tag) => void;
}

export default function BusinessTagPill({ tag, onRemove }: Props) {
  const colors = getTagColors(tag.name, tag.context);
  const label = tag.label || titleizeTagName(tag.name);

  const tooltipTitle = tag.description ? (
    <Box textAlign='center'>
      <Typography fontSize='0.85rem' lineHeight={1.4}>
        {tag.description}
      </Typography>
      <Typography fontSize='0.85rem' lineHeight={1.4}>
        Flagged On: {formatDate(tag.created_at)}
      </Typography>
    </Box>
  ) : tag.created_at ? (
    <Box textAlign='center'>
      <Typography fontSize='0.85rem' lineHeight={1.4}>
        Added On: {formatDate(tag.created_at)}
      </Typography>
    </Box>
  ) : (
    ''
  );

  const pill = (
    <Box
      display='inline-flex'
      alignItems='center'
      gap={0.5}
      px={1}
      py={0.25}
      mr={0.5}
      mb={0.5}
      borderRadius='100px'
      border={onRemove ? `1px solid ${colors.border}` : undefined}
      bgcolor={colors.bg}
      sx={{ cursor: 'default' }}
    >
      <Typography fontSize={12} fontWeight={500} color={colors.color} lineHeight={1.6} noWrap>
        {label}
      </Typography>
      {onRemove && (
        <Box
          component='span'
          display='inline-flex'
          alignItems='center'
          onClick={() => onRemove(tag)}
          sx={{ cursor: 'pointer', color: colors.color, lineHeight: 0 }}
        >
          <RxCross2 size={14} />
        </Box>
      )}
    </Box>
  );

  if (!tooltipTitle) {
    return pill;
  }

  return (
    <Tooltip
      title={tooltipTitle}
      placement='top'
      arrow
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'black',
            color: 'white',
            boxShadow: 3,
            fontSize: '0.85rem',
            borderRadius: 1,
            p: 1,
            lineHeight: 1.2
          }
        },
        arrow: {
          sx: { color: 'black' }
        }
      }}
    >
      {pill}
    </Tooltip>
  );
}
